import React, { useRef } from "react";
import { Container } from "react-bootstrap";
import First from "../First_section/First";
import "./Second.css";
import arrow from "../../../../Asset/arrow-right.svg";
import first from "../../../../Asset/services-first.png";
import second from "../../../../Asset/services-second.png";
import third from "../../../../Asset/services-third.png";
import fourth from "../../../../Asset/services-fourth.png";
import { useNavigate } from "react-router-dom";

const Second = () => {
  const navigate = useNavigate();
  const customSoftwareRef = useRef(null);
  const uiuxDesignRef = useRef(null);
  const cloudComputingRef = useRef(null);
  const aiIotRef = useRef(null);
  const scrollToSection = (sectionId) => {
    switch (sectionId) {
      case "custom-software-development":
        customSoftwareRef.current.scrollIntoView({ behavior: "smooth" });
        break;
      case "uiux-design-development":
        uiuxDesignRef.current.scrollIntoView({ behavior: "smooth" });
        break;
      case "cloud-computing":
        cloudComputingRef.current.scrollIntoView({ behavior: "smooth" });
        break;
      case "ai-iot-development":
        aiIotRef.current.scrollIntoView({ behavior: "smooth" });
        break;
      default:
        break;
    }
  };
  return (
    <>
      <First scrollToSection={scrollToSection} />
      <section className="second-extra-services-section">
        <Container>
          <div className="top-text-third-webDevelopment">
            <h2>
              OUR <span> SERVICES </span>
            </h2>
          </div>
          <h3>
            Our Awesome Services To Give You <b>Success</b>
          </h3>
          <div className="row service-sec-2-row">
            <div
              id="custom-software-development"
              ref={customSoftwareRef}
              className="service-sec-2-section-jump jump-mt"
            >
              <div className="section-jump-1-card">
                <div className="col-xl-4 col-md-6 col-sm-12 section-jump-1-card-col-1 ps-2 pe-2 mob-order">
                  <h3>Custom Software Development</h3>
                  <p>
                    Our trained professionals, guide your business toward its
                    unique potential with custom-made software that empowers
                    your brand to form lasting connections with your customers.
                  </p>
                  <div className="jump-redirect-link">
                    <p
                      onClick={() => {
                        navigate("/Services/webDevelopment");
                      }}
                    >
                      <span>Web App Development </span>
                      <img
                        src={arrow}
                        width={20}
                        height={20}
                        className="ms-3"
                        alt="icon"
                      />
                    </p>
                  </div>
                  <div className="jump-redirect-link mob-dev-link">
                    <p
                      onClick={() => {
                        navigate("/Services/mobileApp");
                      }}
                    >
                      <span>Mobile App Development </span>
                      <img
                        src={arrow}
                        width={20}
                        height={20}
                        className="ms-3"
                        alt="icon"
                      />
                    </p>
                  </div>
                </div>
                <div className="col-xl-8 col-md-6 col-sm-12 section-jump-1-card-col-2 ps-2 pe-2">
                  <div className="jump-img-card-wrapper">
                    <img alt="main" src={first} className="w-100" />
                  </div>
                </div>
              </div>
            </div>
            <div
              id="uiux-design-development"
              ref={uiuxDesignRef}
              className="service-sec-2-section-jump jump-mt"
            >
              <div className="section-jump-1-card">
                <div className="col-xl-8 col-md-6 col-sm-12 section-jump-1-card-col-2 ps-2 pe-2">
                  <div className="jump-img-card-wrapper">
                    <img alt="main" src={second} className="w-100" />
                  </div>
                </div>
                <div className="col-xl-4 col-md-6 col-sm-12 section-jump-1-card-col-1 ps-2 pe-2 ">
                  <h3>UI/UX Design & Development</h3>
                  <p>
                    Our creative visualizers design and elevate your brand's
                    impact through compelling graphics, ensuring memorable user
                    experiences that translate into business growth.
                  </p>
                  <div className="jump-redirect-link">
                    <p
                      onClick={() => {
                        navigate("/Services/uiUx");
                      }}
                    >
                      <span>Learn More </span>{" "}
                      <img
                        src={arrow}
                        width={20}
                        height={20}
                        className="ms-3"
                        alt="icon"
                      />
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div
              id="cloud-computing"
              ref={cloudComputingRef}
              className="service-sec-2-section-jump jump-mt"
            >
              <div className="section-jump-1-card">
                <div className="col-xl-4 col-md-6 col-sm-12 section-jump-1-card-col-1 ps-2 pe-2 mob-order">
                  <h3>Cloud Computing</h3>
                  <p>
                    Experience the future of IT with our top-notch cloud
                    computing services made just for you. Tap into the potential
                    of secure cloud services to make your business run smoother
                    and increase productivity.
                  </p>
                  <div className="jump-redirect-link">
                    <p
                      onClick={() => {
                        navigate("/Services/webDevelopment");
                      }}
                    >
                      <span>Learn More </span>{" "}
                      <img
                        src={arrow}
                        width={20}
                        height={20}
                        className="ms-3"
                        alt="icon"
                      />
                    </p>
                  </div>
                </div>
                <div className="col-xl-8 col-md-6 col-sm-12 section-jump-1-card-col-2 ps-2 pe-2">
                  <div className="jump-img-card-wrapper">
                    <img alt="main" src={third} className="w-100" />
                  </div>
                </div>
              </div>
            </div>
            <div
              id="ai-iot-development"
              ref={aiIotRef}
              className="service-sec-2-section-jump jump-mt"
            >
              <div className="section-jump-1-card">
                <div className="col-xl-8 col-md-6 col-sm-12 section-jump-1-card-col-2 ps-2 pe-2">
                  <div className="jump-img-card-wrapper">
                    <img src={fourth} alt="main" className="w-100" />
                  </div>
                </div>
                <div className="col-xl-4 col-md-6 col-sm-12 section-jump-1-card-col-1 ps-2 pe-2 ">
                  <h3>AI & IOT Development</h3>
                  <p>
                    Stay ahead with our top AI & IoT solutions. That turns your
                    data into valuable insights & automates your business to
                    optimize and supercharge business performance.
                  </p>
                  <div className="jump-redirect-link">
                    <p
                      onClick={() => {
                        navigate("/Services/Iot");
                      }}
                    >
                      <span>Learn More </span>
                      <img
                        src={arrow}
                        width={20}
                        height={20}
                        className="ms-3"
                        alt="icon"
                      />
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Second;
